/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAwsMemberAccount extends models.ServiceAccountNativeDetailsBaseForAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAwsMemberAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAwsMemberAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAwsMemberAccount>): ServiceAccountNativeDetailsForAwsMemberAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAwsMemberAccount(), model);
        ServiceAccountNativeDetailsForAwsMemberAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAwsMemberAccount>): ServiceAccountNativeDetailsForAwsMemberAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAwsMemberAccount.newInstance(<ServiceAccountNativeDetailsForAwsMemberAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAwsMemberAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAwsMemberAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAwsMemberAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAwsMemberAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
